import { createFileRoute } from '@tanstack/react-router';

import { DaysOffLayout } from '@/features/days-off/days-off-layout';

export const Route = createFileRoute('/__authenticated/time-offs')({
	staticData: { titleKey: 'navigation.timeOffs' },
	component: DaysOffLayout,
});
